import { render, staticRenderFns } from "./ReferredSubjects.vue?vue&type=template&id=36fba25b&"
import script from "./ReferredSubjects.vue?vue&type=script&lang=js&"
export * from "./ReferredSubjects.vue?vue&type=script&lang=js&"
import style0 from "./ReferredSubjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports